<template>
    <div style="height: 100%;">
      <my-header>
        canvas测试
      </my-header>
      <canvas
          class="output_canvas"
          ref="output_canvas"
          :width="500"
          :height="300"
      ></canvas>
    </div>
</template>
<script>
import { Hands, HAND_CONNECTIONS } from "@mediapipe/hands";
import { Camera } from "@mediapipe/camera_utils";
import { drawConnectors, drawLandmarks } from "@mediapipe/drawing_utils";
import { Field, Button, Toast, Cell, CellGroup, Row, Col } from 'vant'
import { calcAgentBy2DPoint } from '@/utils/mediapipe'

export default {
  name: "HandModel",
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button
  },
  data: function() {
    return {
      camera: null,
      number: null,
      ctx: null,
      width: null,
      height: null,
      timeout: 3,
      waiting: false,
      timer: null,
      rightCount: 0,
      leftCount: 0,
      handsImage: ''
    };
  },
  mounted() {
    this.ctx = this.$refs.output_canvas.getContext("2d");
    this.ctx.beginPath();
    this.ctx.arc(95,50,40,0,2*Math.PI);
    this.ctx.stroke();
  },
  methods: {
  }
}
</script>

<style scoped>
.output_canvas {
  width: 100%;
  height: 100%;
}
.question{
  position: absolute;
  text-align: center;
  width: 100%;
  font-size: 5rem;
}
</style>
